/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React from 'react'
import RemoteXlsxExport from './RemoteXlsxExport'

const XlsxExport = props => <RemoteXlsxExport type="default" {...props} />

export default XlsxExport
